import { useMutation } from '@tanstack/react-query'
import { axiosFilePost, FileEntry } from 'Redux/axiosHelper'

const fileUploadRequest = async ({ payload, newFile }) => {
  const response = await FileEntry(newFile, 'v1/files/request-upload')
  return response.data
}

const fileUploadToServer = async ({ payload, id }) => {
  const response = await axiosFilePost(payload, `v1/files/upload/${id}`)
  return response.data
}

export const useFileUploadToServer = () => {
  return useMutation(fileUploadToServer)
}

export const useFileUploadRequest = () => {
  const uploadToServerMutation = useFileUploadToServer()

  return useMutation(fileUploadRequest, {
    onSuccess: (data, variables) => {
      uploadToServerMutation.mutate({
        id: data._id,
        payload: variables.payload,
      })
    },
  })
}
